import _extends from 'babel-runtime/helpers/extends';
import _objectWithoutProperties from 'babel-runtime/helpers/objectWithoutProperties';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Nav, NavItem, NavLink, Collapse } from 'reactstrap';

import { onLinkClick } from './utils';
import NavigationItem from './NavigationItem';

var NAV_GROUP_SUB_ITEMS_CLASS = "sub-nav";
var NAV_GROUP_DROPDOWN_ITEM_CLASS = "dropdown";
var NAV_GROUP_DROPDOWN_SUB_ITEMS_CLASS = "dropdown-menu";
var NAV_GROUP_DROPDOWN_ITEM_OPEN_CLASS = "show";
var NAV_GROUP_DROPDOWN_SUB_ITEMS_OPEN_CLASS = 'show';
var NAV_GROUP_ICON_CLASS = "group-icon";
var NAV_GROUP_HREF = "#";

var NAV_GROUP_OPEN_ICON = React.createElement(
  'span',
  null,
  'v'
);

var NAV_GROUP_CLOSED_ICON = React.createElement(
  'span',
  null,
  '>'
);

var NavigationGroup = function (_PureComponent) {
  _inherits(NavigationGroup, _PureComponent);

  function NavigationGroup(props) {
    _classCallCheck(this, NavigationGroup);

    var _this = _possibleConstructorReturn(this, (NavigationGroup.__proto__ || Object.getPrototypeOf(NavigationGroup)).call(this, props));

    _this.onGroupClick = function (evt) {
      onLinkClick(evt, function () {
        var _this$props = _this.props,
            onGroupClick = _this$props.onGroupClick,
            item = _this$props.item;

        onGroupClick(item);
      });
    };

    return _this;
  }

  _createClass(NavigationGroup, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          collapsed = _props.collapsed,
          isDropdown = _props.isDropdown,
          openGroupId = _props.openGroupId,
          groupOpenedIcon = _props.groupOpenedIcon,
          groupClosedIcon = _props.groupClosedIcon,
          item = _props.item,
          otherProps = _objectWithoutProperties(_props, ['collapsed', 'isDropdown', 'openGroupId', 'groupOpenedIcon', 'groupClosedIcon', 'item']);

      var id = item.id,
          label = item.label,
          icon = item.icon,
          className = item.className,
          groupIcon = item.groupIcon,
          groupIconOpened = item.groupIconOpened,
          groupIconClosed = item.groupIconClosed,
          items = item.items;


      var isOpen = id === openGroupId;

      var groupIconContent = false;
      if (isOpen) {
        if (groupIconOpened !== void 0) {
          groupIconContent = groupIconOpened;
        } else if (groupIcon !== void 0) {
          groupIconContent = groupIcon;
        } else if (groupOpenedIcon !== void 0) {
          groupIconContent = groupOpenedIcon;
        }
      } else {
        if (groupIconClosed !== void 0) {
          groupIconContent = groupIconClosed;
        } else if (groupIcon !== void 0) {
          groupIconContent = groupIcon;
        } else if (groupClosedIcon !== void 0) {
          groupIconContent = groupClosedIcon;
        }
      }

      if (groupIconContent) {
        groupIconContent = React.createElement(
          'span',
          { className: NAV_GROUP_ICON_CLASS },
          groupIconContent
        );
      }

      var containerClasses = className ? [className] : [];
      var subContainerClasses = [NAV_GROUP_SUB_ITEMS_CLASS];

      if (isDropdown) {
        containerClasses.push(NAV_GROUP_DROPDOWN_ITEM_CLASS);
        subContainerClasses.push(NAV_GROUP_DROPDOWN_SUB_ITEMS_CLASS);
        if (isOpen) {
          containerClasses.push(NAV_GROUP_DROPDOWN_ITEM_OPEN_CLASS);
          subContainerClasses.push(NAV_GROUP_DROPDOWN_SUB_ITEMS_OPEN_CLASS);
        }
      }

      var containerClassName = containerClasses.length > 0 ? containerClasses.join(' ') : null;
      var subContainerClassName = subContainerClasses.length > 0 ? subContainerClasses.join(' ') : null;

      var itemProps = _extends({}, otherProps, { isDropdown: isDropdown, nested: true
      });

      var subNav = React.createElement(
        Nav,
        { className: subContainerClassName },
        items.map(function (child) {
          return React.createElement(NavigationItem, _extends({}, itemProps, { key: child.id, item: child }));
        })
      );

      var subContent = !isDropdown ? React.createElement(
        Collapse,
        { 'in': isOpen, isOpen: isOpen },
        subNav
      ) : subNav;

      return React.createElement(
        NavItem,
        { key: id, role: 'presentation', className: containerClassName },
        React.createElement(
          NavLink,
          { href: NAV_GROUP_HREF, onClick: this.onGroupClick },
          icon,
          label,
          groupIconContent
        ),
        subContent
      );
    }
  }]);

  return NavigationGroup;
}(PureComponent);

NavigationGroup.propTypes = {
  collapsed: PropTypes.bool,
  isItemActive: PropTypes.func,
  formatItemPath: PropTypes.func,
  isPrimary: PropTypes.bool,
  isDropdown: PropTypes.bool,
  openGroupId: PropTypes.any,
  groupOpenedIcon: PropTypes.any,
  groupClosedIcon: PropTypes.any,
  onItemClick: PropTypes.func.isRequired,
  onGroupClick: PropTypes.func.isRequired,
  item: PropTypes.object.isRequired
};
export default NavigationGroup;